import React from 'react';
import {useTranslation} from 'react-i18next';
import {UPLOAD_PHOTO_STATES} from '../constants';
import {usePhotoBoxStore} from '../store';
import {Button} from '@chekin/guestapp-ui-kit';
import {ButtonsWrapper} from './styled';

type ButtonsProps = {
  state: UPLOAD_PHOTO_STATES;
  onChange?: () => void;
  onCapture?: () => void;
  onFinishUploadPhoto?: () => void;
  disabled?: boolean;
};
const Buttons = ({
  state,
  onChange,
  onCapture,
  onFinishUploadPhoto,
  disabled,
}: ButtonsProps) => {
  const uploadedImage = usePhotoBoxStore(state => state.uploadedImage);
  const {t} = useTranslation();

  const getButtons = React.useCallback(() => {
    switch (state) {
      case UPLOAD_PHOTO_STATES.take:
        return (
          <Button variant="outline" onClick={onCapture} disabled={disabled} size="md">
            {t('take_photo')}
          </Button>
        );
      case UPLOAD_PHOTO_STATES.scan:
        return (
          <Button onClick={onCapture} disabled={disabled} size="md">
            {t('scan_document')}
          </Button>
        );
      case UPLOAD_PHOTO_STATES.upload:
        return (
          <>
            <Button
              onClick={onFinishUploadPhoto}
              disabled={disabled || !uploadedImage}
              size="md"
            >
              {t('start_verification')}
            </Button>
            <Button
              variant="outline"
              disabled={disabled || !uploadedImage}
              onClick={onChange}
              size="md"
            >
              {t('change_photo')}
            </Button>
          </>
        );
    }
  }, [state, t, onCapture, onFinishUploadPhoto, disabled, onChange, uploadedImage]);

  return (
    <ButtonsWrapper className="photo-box__btns kiosko:mt-[114px]">
      {getButtons()}
    </ButtonsWrapper>
  );
};

export {Buttons};
